import classNames from 'classnames';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';

import { getLoggedIn } from '../app/redux/auth';
import routes from '../app/routes';
import ErrorBoundary from '../components/ErrorBoundary';
import { InnerContentScrollbars } from '../components/layout/InnerContentScrollbars';
import {
  HorizontalTrackTypes,
  Scrollbars,
} from '../components/layout/Scrollbars';
import { useScrollbarsStyles } from '../components/layout/Scrollbars.styles';
import { useSilentLogout } from '../hooks/data/auth';
import NonLoggedFooter from '../widgets/NonLoggedFooter';
import NonLoggedHeader from '../widgets/NonLoggedHeader';
import NonLoggedTopBar from '../widgets/NonLoggedTopBar';
import { useNonLoggedPageStyles } from './NonLoggedPage.styles';

export default function NonLoggedPage({
  id,
  className,
  children,
  logoutUser = false,
  centered = false,
}) {
  const { styles: scrollbarsStyles } = useScrollbarsStyles();
  const { styles } = useNonLoggedPageStyles(scrollbarsStyles);
  const location = useLocation();
  const loggedIn = useSelector(getLoggedIn);
  const logout = useSilentLogout();

  const redirect = location.state?.from?.pathname || routes.root;

  useEffect(() => {
    if (logoutUser && loggedIn) {
      logout();
    }
  }, [loggedIn, logoutUser, logout]);
  if (!logoutUser && loggedIn) {
    return <Redirect to={redirect} />;
  }

  return (
    <Scrollbars
      id={id}
      className={classNames(styles.root, className)}
      horizontal={HorizontalTrackTypes.BOTTOM}
    >
      <div className={styles.content}>
        <NonLoggedTopBar />
        <NonLoggedHeader />
        <div className={styles.innerContent}>
          <InnerContentScrollbars>
            <ErrorBoundary messageId="error.render.page">
              <div
                className={classNames(styles.scrollContent, {
                  [styles.scrollContentCentered]: centered,
                })}
              >
                {children}
              </div>
            </ErrorBoundary>
          </InnerContentScrollbars>
        </div>
        <NonLoggedFooter />
      </div>
    </Scrollbars>
  );
}
